/**
 * Phone number check for the S/PLUS account drawer sign-up forms
 * (blocks/_signup-account.liquid and blocks/_signup-account_non-member.liquid).
 *
 * Normalises like the custom-form section (sections/custom-form.liquid): in the AU and NZ markets a number
 * is sent in international (E.164) format, so 0412 345 678 -> +61412345678 and 021 123 4567 -> +64211234567.
 * Numbers typed with + or 00 keep their country code. Other markets are sent as typed.
 *
 * window.SalomonPhone.check(value, market) returns { valid, value, message }:
 *   valid    false when the value can't be a phone number for its country
 *   value    what to submit ('' for an empty field, which is always valid)
 *   message  the error to show when not valid
 */
(function () {
  'use strict';

  // `length` is the digit count of a full international number, used to tell "61412345678"
  // (typed without the +) from a national number.
  var MARKETS = {
    AU: { dial: '61', length: 11 },
    NZ: { dial: '64', length: 10 }
  };

  // Checked against the E.164 number. AU: 9 digits after +61 (landlines 2, 3, 7, 8 and mobiles 4).
  // NZ: 8 to 10 digits after +64 (landlines are 8, mobiles 8 to 10).
  var RULES = {
    '61': {
      pattern: /^\+61[2-478]\d{8}$/,
      message: 'Please enter a valid Australian phone number, e.g. 0412 345 678.'
    },
    '64': {
      pattern: /^\+64[2-9]\d{7,9}$/,
      message: 'Please enter a valid New Zealand phone number, e.g. 021 123 4567.'
    }
  };
  var GENERIC_PATTERN = /^\+?\d{6,15}$/;
  var GENERIC_MESSAGE = 'Please enter a valid phone number.';

  // Invisible characters that paste and autofill wrap numbers in (iOS and Android add bidi marks
  // around numbers copied from contacts), plus zero-width spaces and the BOM.
  var INVISIBLE = /[­​-‏‪-‮⁠-⁩﻿]/g;
  // Digits, + and the separators people type numbers with.
  var ALLOWED = /^[\d+\s().\-\/‐-―−]*$/;

  function clean(value) {
    var text = String(value == null ? '' : value);
    // Full-width digits and + (East Asian keyboards) become 0-9 and +.
    if (text.normalize) text = text.normalize('NFKC');
    return text.replace(INVISIBLE, '').trim();
  }

  // "+61 (0) 412-345 678" -> "+610412345678", "0061 412 345 678" -> "+61412345678".
  function compact(text) {
    return text.replace(/[^\d+]/g, '').replace(/^00/, '+');
  }

  function normalize(value, market) {
    var text = clean(value);
    var config = MARKETS[market];
    if (!config) return text;

    var phone = compact(text);
    if (!phone) return '';
    // "+61 (0) 4xx" keeps the national trunk 0 after the country code.
    if (phone.charAt(0) === '+') return phone.replace(/^\+(61|64)0/, '+$1');
    if (phone.charAt(0) === '0') return '+' + config.dial + phone.slice(1);
    if (phone.indexOf(config.dial) === 0 && phone.length >= config.length) return '+' + phone;
    return '+' + config.dial + phone;
  }

  function check(value, market) {
    var text = clean(value);
    if (!text) return { valid: true, value: '', message: '' };

    var config = MARKETS[market];
    var phone = normalize(text, market);
    // AU/NZ numbers are already E.164. Elsewhere only a number typed with its country code can be checked
    // against that country's rule.
    var international = config ? phone : compact(text).replace(/^\+(61|64)0/, '+$1');
    var countryCode = (international.match(/^\+(61|64)/) || [])[1];
    if (!countryCode && international.charAt(0) !== '+' && config) countryCode = config.dial;
    var rule = RULES[countryCode];

    var valid =
      ALLOWED.test(text) &&
      /^\+?\d+$/.test(international) &&
      (rule ? rule.pattern : GENERIC_PATTERN).test(international);

    return { valid: valid, value: phone, message: valid ? '' : rule ? rule.message : GENERIC_MESSAGE };
  }

  window.SalomonPhone = { check: check, normalize: normalize };
})();
